import { render, staticRenderFns } from "./companyAddress.vue?vue&type=template&id=1962fb53&"
import script from "./companyAddress.vue?vue&type=script&lang=ts&"
export * from "./companyAddress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports